import { useShallow } from "zustand/react/shallow";
import { usePanelStore } from "../../stores/panelStore";

export function useMainPanelPanelState() {
  return usePanelStore(
    useShallow((state) => ({
      sceneGraphOpen: state.sceneGraphOpen,
      setSceneGraphOpen: state.actions.setSceneGraphOpen,
      filePanelOpen: state.filePanelOpen,
      setFilePanelOpen: state.actions.setFilePanelOpen,
      animationPanelOpen: state.animationPanelOpen,
      setAnimationPanelOpen: state.actions.setAnimationPanelOpen,
      materialEditorPanelOpen: state.materialEditorPanelOpen,
      setMaterialEditorPanelOpen: state.actions.setMaterialEditorPanelOpen,
      lightsPanelOpen: state.lightsPanelOpen,
      setLightsPanelOpen: state.actions.setLightsPanelOpen,
      circleDetectionOpen: state.circleDetectionOpen,
      setCircleDetectionOpen: state.actions.setCircleDetectionOpen,
      historyPanelOpen: state.historyPanelOpen,
      setHistoryPanelOpen: state.actions.setHistoryPanelOpen,
      runtimeDebugOpen: state.runtimeDebugOpen,
      setRuntimeDebugOpen: state.actions.setRuntimeDebugOpen,
      ikTargetPanelOpen: state.ikTargetPanelOpen,
      setIkTargetPanelOpen: state.actions.setIkTargetPanelOpen,
      objectLibraryOpen: state.objectLibraryPanelOpen,
      setObjectLibraryOpen: state.actions.setObjectLibraryPanelOpen,
      runtimeControlsOpen: state.runtimeControlsOpen,
      setRuntimeControlsOpen: state.actions.setRuntimeControlsOpen,
      physicsPanelOpen: state.physicsPanelOpen,
      setPhysicsPanelOpen: state.actions.setPhysicsPanelOpen,
      actuatorControlsOpen: state.actuatorControlsOpen,
      setActuatorControlsOpen: state.actions.setActuatorControlsOpen,
      warmstartDatasetOpen: state.warmstartDatasetOpen,
      setWarmstartDatasetOpen: state.actions.setWarmstartDatasetOpen,
      behaviorEditorOpen: state.behaviorEditorOpen,
      setBehaviorEditorOpen: state.actions.setBehaviorEditorOpen,
      policyRolloutOpen: state.policyRolloutOpen,
      setPolicyRolloutOpen: state.actions.setPolicyRolloutOpen,
      trainingMetricsOpen: state.trainingMetricsOpen,
      setTrainingMetricsOpen: state.actions.setTrainingMetricsOpen,
      trainingPipelineOpen: state.trainingPipelineOpen,
      setTrainingPipelineOpen: state.actions.setTrainingPipelineOpen,
      octoTrainingOpen: state.octoTrainingOpen,
      setOctoTrainingOpen: state.actions.setOctoTrainingOpen,
      meshEditorOpen: state.meshEditorOpen,
      setMeshEditorOpen: state.actions.setMeshEditorOpen,
      sceneInventoryOpen: state.sceneInventoryOpen,
      setSceneInventoryOpen: state.actions.setSceneInventoryOpen,
      modelCheckOpen: state.modelCheckOpen,
      setModelCheckOpen: state.actions.setModelCheckOpen,
      massPropertiesOpen: state.massPropertiesOpen,
      setMassPropertiesOpen: state.actions.setMassPropertiesOpen,
      measurementsOpen: state.measurementsOpen,
      setMeasurementsOpen: state.actions.setMeasurementsOpen,
      setVisibilitySettingsOpen: state.actions.setVisibilitySettingsOpen,
      terrainPanelOpen: state.terrainPanelOpen,
      setTerrainPanelOpen: state.actions.setTerrainPanelOpen,
      xmlSourcePanelOpen: state.xmlSourcePanelOpen,
      setXmlSourcePanelOpen: state.actions.setXmlSourcePanelOpen,
      cameraProbeOpen: state.cameraProbeOpen,
      setCameraProbeOpen: state.actions.setCameraProbeOpen,
      sensorsOpen: state.sensorsOpen,
      setSensorsOpen: state.actions.setSensorsOpen,
      shortcutsPanelOpen: state.shortcutsPanelOpen,
      setShortcutsPanelOpen: state.actions.setShortcutsPanelOpen,
      getUpdatesPanelOpen: state.getUpdatesPanelOpen,
      setGetUpdatesPanelOpen: state.actions.setGetUpdatesPanelOpen,
      sendFeedbackPanelOpen: state.sendFeedbackPanelOpen,
      setSendFeedbackPanelOpen: state.actions.setSendFeedbackPanelOpen,
      setAboutPanelOpen: state.actions.setAboutPanelOpen,
      gremlinsPanelOpen: state.gremlinsPanelOpen,
      setGremlinsPanelOpen: state.actions.setGremlinsPanelOpen,
    }))
  );
}
